import React from 'react';
import EquipmentCard from '../equipment/EquipmentCard';

const MainContent = ({ 
  systems, 
  removeSystem, 
  handleSystemParamChange, 
  darkMode, 
  solarEnabled, 
  setSolarEnabled,
  globalParams,
  isMobile // isMobile prop'unu ekleyelim
}) => {
  return (
    <div className={`${isMobile ? 'ml-0' : 'ml-72'} pt-6 pb-6 transition-all duration-300 pr-10 pl-10`}>
      {/* Sidebar genişlediği için ml-72 yerine ml-96 kullanıyoruz */}
      {/* Ayrıca sağ ve sol kenar boşlukları ekledik (pr-8 pl-4) */}
      
      <div className="grid grid-cols-1 gap-6 mt-8 max-w-8xl mx-auto">
        {/* max-w-5xl ile maksimum genişliği sınırlandırıyoruz */}
        {/* mx-auto ile içeriği ortalıyoruz */}
        
        {systems.length === 0 ? (
          <div className={`flex flex-col items-center justify-center h-64 ${darkMode ? 'bg-gray-800' : 'bg-white'} rounded-xl shadow-lg p-8 text-center`}>
            <img src="/icons/logo192.png" alt="Logo" className="h-24 w-24 mb-4 opacity-30" />
            <h3 className={`text-xl font-semibold ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>Sistem Ekleyin</h3>
            <p className={`mt-2 ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>
              Sol menüden ekipman seçerek ısı pompa sistemleri oluşturun
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6">
            {systems.map((system) => (
              <EquipmentCard 
                key={system.id}
                system={system}
                onRemove={removeSystem}
                onParamChange={handleSystemParamChange}
                darkMode={darkMode}
                solarEnabled={solarEnabled}
                setSolarEnabled={setSolarEnabled}
                globalParams={globalParams}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MainContent;